// src/state/modules/permissions.js
import apiClient from '@/api'

export const namespaced = true

export const state = () => ({
    // { [permissionId]: permissionName }
    map: {}
})

export const mutations = {
    SET_MAP(state, map) {
        state.map = map || {}
    },
    CLEAR_MAP(state) {
        state.map = {}
    }
}

export const actions = {
    async fetchPermissionsMap({ commit }) {
        const { data } = await apiClient.get('api/v1/permissions/map')
        commit('SET_MAP', data?.result || {})
    },

    clearMap({ commit }) {
        commit('CLEAR_MAP')
    }
}

export const getters = {
    permissionById: (state) => (id) => state.map[id] || null,

    hasPermission: (state, _getters, rootState) => (permissionName) => {
        const permId = Object.keys(state.map).find(id => state.map[id] === permissionName)
        if (!permId) return false

        const companies   = rootState.company.companies || []
        const currentUuid = localStorage.getItem('company')
        const company     = companies.find(c => c.CompanyUUID === currentUuid)
        if (!company) return false

        return Array.isArray(company.permissions) && company.permissions.includes(permId)
    }
}
